import { Box, Grid, ThemeProvider, Typography } from "@mui/material";
import { pageTheme } from "../../ayudas/Themes";
import { SupportAgent } from "@mui/icons-material";

export default function Support() {

  return (
    <ThemeProvider theme={pageTheme}>
      <Box style={{ width: "100%" }}>
        <Typography variant="pageTitle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            className="rt-icon-header"
          >
            <path
              d="M15.4381 0.921875C12.6161 0.925662 9.88759 1.93368 7.74095 3.76549C5.59432 5.5973 4.1697 8.13331 3.72211 10.9196C3.62563 11.5276 0.69928 27.0779 0.69928 27.0779L9.40299 22.999C10.974 23.9272 12.7379 24.4804 14.5575 24.6158C16.3772 24.7511 18.2036 24.4649 19.8946 23.7794C21.5856 23.0938 23.0957 22.0274 24.3074 20.6632C25.5191 19.2989 26.3998 17.6735 26.8809 15.9134C27.3621 14.1533 27.4307 12.3059 27.0815 10.5149C26.7323 8.72398 25.9747 7.03771 24.8676 5.58726C23.7605 4.13681 22.3338 2.9613 20.6983 2.15213C19.0628 1.34297 17.2628 0.921968 15.4381 0.921875ZM14.8671 6.12956C15.1814 6.12969 15.4887 6.22304 15.75 6.39779C16.0113 6.57255 16.2149 6.82086 16.3351 7.11134C16.4553 7.40181 16.4866 7.7214 16.4252 8.02969C16.3637 8.33798 16.2122 8.62112 15.9898 8.84331C15.7675 9.06549 15.4842 9.21675 15.1758 9.27795C14.8675 9.33915 14.5479 9.30754 14.2576 9.18712C13.9672 9.06671 13.7191 8.86289 13.5445 8.60144C13.37 8.33999 13.2769 8.03266 13.277 7.7183C13.2769 7.50952 13.318 7.30277 13.3979 7.10988C13.4777 6.91699 13.5949 6.74175 13.7426 6.59418C13.8903 6.44661 14.0656 6.32962 14.2586 6.24989C14.4515 6.17017 14.6583 6.12928 14.8671 6.12956ZM17.1854 19.4633H13.5784C13.3638 19.4633 13.1581 19.3781 13.0064 19.2264C12.8547 19.0747 12.7695 18.869 12.7695 18.6544C12.7695 18.4399 12.8547 18.2342 13.0064 18.0825C13.1581 17.9308 13.3638 17.8455 13.5784 17.8455H14.0846V12.6101H13.9908C13.7545 12.6101 13.5268 12.5216 13.3525 12.362C13.1782 12.2024 13.0701 11.9833 13.0494 11.748C13.0286 11.5126 13.0968 11.278 13.2405 11.0904C13.3842 10.9028 13.5929 10.7758 13.8256 10.7345C13.8586 10.7279 14.8948 10.523 15.7104 10.3618C15.8288 10.3382 15.9509 10.3412 16.0681 10.3705C16.1852 10.3999 16.2943 10.4548 16.3876 10.5315C16.4809 10.6081 16.5561 10.7045 16.6076 10.8136C16.6592 10.9228 16.6859 11.042 16.6858 11.1628V17.8455H17.1854C17.4 17.8455 17.6057 17.9307 17.7574 18.0825C17.9091 18.2341 17.9943 18.4399 17.9943 18.6544C17.9943 18.869 17.9091 19.0747 17.7574 19.2264C17.6057 19.3781 17.4 19.4633 17.1854 19.4633L17.1854 19.4633Z"
              fill={"#c59d48"}
            />
          </svg>
          Support
        </Typography>

        <Box className="con-box-style">
          <Grid container spacing={3} style={{ marginBottom: "16px" }}>
            <Grid item md={4} textAlign={"center"}>
              <Box
                style={{
                  paddingRight: "16px",
                }}
              >
                <SupportAgent sx={{ fontSize: "200px" }} />
              </Box>
            </Grid>
            <Grid
              item
              md={8}
              style={{ display: "inline-block", verticalAlign: "top" }}
            >
              <Box className="container-about">
                <Typography variant="h5" style={{ marginBottom: "10px" }}>
                  Info
                </Typography>
               
                <Typography className="about-header" style={{ margin: "26x" }}>
                  In case of any doubt or support, please send an email to the
                  following address
                </Typography>
                <Typography variant="subtitle1">support@reveald.com</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
